import AuthMutations from '../../graphql/auth/mutations';
/* import LicensingQueries from '../../graphql/licensing/queries';
import { canUseBaconNormalizer } from '../normilizers/licensing'; */

const setUserLogin = ({
  accessToken,
  rt,
  userConsumer,
  userId,
  userIsAdmin = false, // by default is false
  eulaAccepted,
  permissions,
  passwordUpdateRequired,
  organization,
  username
}) => {
  localStorage.setItem('auth.accessToken', accessToken);
  localStorage.setItem('auth.refreshToken', rt);
  localStorage.setItem('user.id', userId);
  localStorage.setItem('user.is_admin', userIsAdmin);
  localStorage.setItem('user.eulaAccepted', eulaAccepted);
  localStorage.setItem('user.permissions', JSON.stringify(permissions || []));
  localStorage.setItem('user.passwordUpdateRequired', passwordUpdateRequired);
  localStorage.setItem('user.organization', JSON.stringify(organization || []));
  localStorage.setItem('user.username', username);
  userConsumer.setUser({
    accessToken,
    loggedIn: true,
    userId,
    isAdmin: userIsAdmin,
    eulaAccepted,
    permissions,
    passwordUpdateRequired,
    organization,
    username,
  });
};

const logout = () => {
  localStorage.removeItem('auth.refreshToken');
  localStorage.removeItem('auth.accessToken');
  localStorage.removeItem('user.eulaAccepted');
  localStorage.removeItem('user.permissions');
  localStorage.removeItem('user.id');
  localStorage.removeItem('user.role');
  localStorage.removeItem('user.is_admin');
  localStorage.removeItem('user.passwordUpdateRequired');
  localStorage.removeItem('user.organization');
  localStorage.removeItem('user.username');
};

const refreshToken = async (client, rt) => {
  if (rt) {
    const res = await client.mutate({
      mutation: AuthMutations.AUTH_REFRESH_TOKEN,
      variables: { refresh: rt },
    });
    if (
      res &&
      res.data &&
      res.data.refreshTokenResponse &&
      res.data.refreshTokenResponse.access
    ) {
      const newAccessToken = res.data.refreshTokenResponse.access;
      localStorage.setItem('auth.accessToken', newAccessToken);
      return newAccessToken;
    }
  }
};

const getAuthorizationHeader = () => {
  const authAccessToken = localStorage.getItem('auth.accessToken');
  return `Bearer ${authAccessToken}`;
};

/* const checkBaconLicenses = async client => {
  // If the user gets a 403 error the options are:
  // 1- The user does not have permission to perform the action
  // 2- The are no valid licenses
  // 3- The number of endpoints is greater than the allowed
  // We check if the user can use bacon
  const res = await client.query({ query: LicensingQueries.CAN_USE_BACON });
  if (res && res.data && res.data.canUseBaconResponse) {
    const {
      canUseBacon,
      validLicenses,
      endpointsExceeded,
    } = canUseBaconNormalizer(res.data.canUseBaconResponse);
    if (!canUseBacon) {
      localStorage.setItem('licensing.vl', validLicenses);
      localStorage.setItem('licensing.ee', endpointsExceeded);
      // eslint-disable-next-line no-restricted-globals
      location.href = '/licensing';
    }
  }
  return null;
}; */

export {
  setUserLogin,
  logout,
  refreshToken,
  getAuthorizationHeader,
  /* checkBaconLicenses, */
};
